import { ITypedBaseResponse } from "@nkr/models/base-response";
import { IStrongBoxFilter, IStrongBoxCenterUsageListing } from "@nkr/models/strong-box";
import { AuthActionCreators } from "@nkr/store/authorization";
import { useAppHookContext } from "@nkr/utils/rest-api";
import { useEffect, useState } from "react";

interface IRetVal {
    list: IStrongBoxCenterUsageListing[],
    loading: boolean,
    error: string
}

const useStrongBoxUsages = (filter?: IStrongBoxFilter): IRetVal => {
    const { dispatch } = useAppHookContext();

    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string>('');
    const [list, setList] = useState<IStrongBoxCenterUsageListing[]>([]);

    useEffect(() => {
        if (filter) {
            setLoading(true);
            setError('');

            const fetchData = async () => {
                let config = {
                    url: `${__API__}/strongbox/usage/search`,
                    data: filter
                };

                try {
                    const response: ITypedBaseResponse<IStrongBoxCenterUsageListing[]> = await dispatch(AuthActionCreators.apiPost(config));

                    if (response && response.data.results && response.data.success) {
                        setList(response.data.results);
                    } else {
                        setError('Unable to load data');
                        setList([]);
                    }
                } catch (err) {
                    setList([]);
                    setError(err);
                } finally {
                    setLoading(false);
                }
            }

            fetchData();
        }
    }, [filter]);

    return { list, loading, error }
}

export default useStrongBoxUsages;
